import { getRequest } from '../services/requestHandler';
import { BsgGloveSize } from '../models';

// Model: TourApp.Data/Models/PlayerRegionLookup
export const getBsgGloveSizes = async () => {
  const url = 'bsgGlove/getBsgGloveSize?activeOnly=true';
  const response = await getRequest<BsgGloveSize>('GetBsgGloveSizes', url);
  return response;
};
